import { render, staticRenderFns } from "./ebs-create-ticket.component.vue?vue&type=template&id=7dabd402&"
import script from "./ebs-create-ticket.component.vue?vue&type=script&lang=js&"
export * from "./ebs-create-ticket.component.vue?vue&type=script&lang=js&"
import style0 from "./ebs-create-ticket.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports